import { useSelector } from 'react-redux';
import MessagingEmbed from '../../components/messaging-embed/MessagingEmbed';

export default function MessagingEmbedPage() {
  const user = useSelector(s => s.user);
  return (
    <div className='page messaging-embed-page'>
      <h1 className='page-title'>Messaging Embed POC</h1>
      <MessagingEmbed
        // useApi switched off; using static JSON config
        useApi={false}
        pageType='messaging'
        userId={user?.userId}
        customerId={user?.customerId}
        theme='default'
        locale='en-US'
        allowedActions={['view','send','edit']}
        enableAutoResize={true}
        height='600px'
      />
    </div>
  );
}
